<template>

  <div ref="whole_page" id="teacher-qa"> 
    <vx-card id="addShortCourseBundle" :title="'Select a module'" class="w-full mb-6">
      <div v-if="data.length">
        <vs-table
          ref="courseTable"
          stripe
          class="vs-con-loading__container"
          single
          pagination
          :max-items="itemsPerPage"
          search
          :data="data"
          @selected="handleSelectedModule"
        >
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
            <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
              <h3 class="ml-2">Your modules with questions</h3>
            </div>
            <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div
                class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span
                  class="mr-2"
                >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ data.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : data.length }} of {{ data.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <template slot="thead">
            <vs-th sort-key="gradeName">Grade</vs-th>
            <vs-th sort-key="classroom">Classroom</vs-th>
            <vs-th sort-key="moduleName">Subject</vs-th>
            <vs-th sort-key="subjectName">Module</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="module" :key="indextr" v-for="(module, indextr) in data">
              <vs-td :data="data[indextr].gradeName">{{ module.gradeName}}</vs-td>

              <vs-td :data="data[indextr].classroom">{{ module.classroom}}</vs-td>

              <vs-td :data="data[indextr].subjectName">{{ module.moduleName }}</vs-td>

              <vs-td :data="data[indextr].module">{{ module.subjectName }}</vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </div> 
      <div v-else>
        <h2>No Data To Display</h2>
      </div> 
    </vx-card>

    <vx-card v-if="selectedModule && selectedModule.tasks" id="addShortCourseBundle" :title="'Select a Task'" class="w-full mb-6">
      <div>
        <vs-table
          ref="courseTable"
          stripe
          class="vs-con-loading__container"
          single
          pagination
          :max-items="itemsPerPage"
          search
          :data="selectedModule.tasks"
          @selected="handleSelectedTask"
        >
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
            
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div
                class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span
                  class="mr-2"
                >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ selectedModule.tasks.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : selectedModule.tasks.length }} of {{ selectedModule.tasks.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <template slot="thead">
            <vs-th sort-key="topicName">Topic</vs-th>
            <vs-th sort-key="taskName">Task</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="task" :key="indextr" v-for="(task, indextr) in data">
              <vs-td :data="data[indextr].topicName">{{ task.topicName}}</vs-td>

              <vs-td :data="data[indextr].taskName">{{ task.taskName }}</vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
    
    <vx-card v-if="selectedTask && selectedTask.questions" id="addShortCourseBundle" :title="'Select a Task'" class="w-full mb-6">
      <div>
        <vs-table
          ref="courseTable"
          stripe
          class="vs-con-loading__container"
          single
          pagination
          :max-items="itemsPerPage"
          search
          :data="selectedTask.questions"
          @selected="handleSelectedQuestion"
        >
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
            
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div
                class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span
                  class="mr-2"
                >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ selectedTask.questions.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : selectedTask.questions.length }} of {{ selectedTask.questions.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <template slot="thead">
            <vs-th sort-key="question">Question</vs-th>
            <vs-th sort-key="answer">Answer</vs-th>
            <vs-th sort-key="studentName">Student Name</vs-th>
            <vs-th sort-key="dateAsked">Date Asked</vs-th>
            <vs-th sort-key="dateAnswered">Date Answered</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="question" :key="indextr" v-for="(question, indextr) in data">
              <vs-td :data="data[indextr].question">{{ question.question}}</vs-td>

              <vs-td :data="data[indextr].answer">{{ question.answer }}</vs-td>

              <vs-td :data="data[indextr].studentName">{{ question.studentName }}</vs-td>

              <vs-td :data="data[indextr].dateAsked">{{ question.dateAsked }}</vs-td>

              <vs-td :data="data[indextr].dateAnswered">{{ question.dateAnswered }}</vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>

    <vs-popup title="Anwser a question" id="init-chat-popup" :active.sync="popupActive">
      <div v-if="selectedQuestion">
        <div class="vx-row">
          <div class="vx-col w-full">
            <label>Grade: <strong> {{selectedModule.gradeName}}</strong></label>
            <br>
            <label>Module: <strong>{{selectedModule.moduleName}}</strong></label>
            <br>
            <label>Subject: <strong>{{selectedModule.subjectName}}</strong></label>
            <br>
            <label>Topic: <strong>{{selectedTask.topicName}}</strong></label>
            <br>
            <label>Task: <strong>{{selectedTask.taskName}}</strong></label>
            <br>
            <label>Student: <strong>{{selectedQuestion.studentName}}</strong></label>
            <br>
            <label>Date asked: <strong>{{selectedQuestion.dateAsked}}</strong></label>
            <br>
          </div>
          <div class="vx-col w-full">
            <label>Date answer: <strong>{{selectedQuestion.dateAnswered}}</strong></label>
            <br>
          </div>
        </div>
        <vs-divider />
        <div class="vx-row">
          <div class="vx-col w-full">
            <label for="chat_name">Question</label>
            <vs-textarea :disabled="true" autocomplete="off" class="w-full mt-1" v-model="selectedQuestion.question" />
          </div>
          <div class="vx-col w-full">
            <label for="chat_name">Enter your answer</label>
            <vs-textarea class="w-full mt-1" v-model="teacherAnswer" />
          </div>
        </div>
        
        <div class="vx-row mt-3">
          <div class="vx-col w-full">
            <label for="is-answer-public">Public reply</label>
            <vs-checkbox id="is-answer-public" v-model="publicAnswer"/>
          </div>
        </div>

        <div class="vx-row mt-3">
          <vs-spacer></vs-spacer>
          <div class="vx-col">
            <vs-button class="vs-con-loading__container" ref="submit_btn" @click="submitAnswerForQuestion">Submit</vs-button>
          </div>
          <div class="vx-col">
            <vs-button icon-pack="feather" icon="icon-trash" type="flat" color="danger" class="vs-con-loading__container" @click="deleteQuestion">Delete</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

  </div>
  
</template> 


<script>
export default {
  data() {
    return { 
      data:[],
      itemsPerPage:5,
      currentPage:1,
      teacherAnswer:"",
      popupActive:false,
      publicAnswer:false,
      selectedModule:null,
      selectedTask:null,
      selectedQuestion:null
    }
  },
  components:{ 

  },
  watch:{ 

  },
  computed: {

  },
  methods: { 
    closeAllMenus(){
      var self = this;
      self.popupActive = false;
      self.selectedQuestion = false;
      self.selectedTask = null;
      self.selectedModule = null;
      
    },
    handleSelectedModule(module){
      var self = this;
      self.selectedModule = module;
    },
    handleSelectedTask(task){
      var self = this;
      self.selectedTask = task;
    },
    handleSelectedQuestion(question){
      var self = this;
      self.selectedQuestion = question;
      self.popupActive = true;
      self.publicAnswer = question.isPublic,
      self.teacherAnswer = question.answer
    },
    showPopUpForQuestion(questionId){
      var self = this;
      self.popupActive = true;
    },
    deleteQuestion(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");
      var onSuccess = response =>{
        self.$vs.notify({
              title:'Information',
              color: "success",
              text: "Question Deleted",
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-check'
            });
        self.closeAllMenus();
        self.getQuestions();
      }
    
      var onFinally = response =>{
      }
    
      self.$ajaxGet(self, `teacher/TaskQA/deleteQuestion/${self.selectedQuestion.id}` , onSuccess, onFinally);
    },
    submitAnswerForQuestion(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");
      var onSuccess = response =>{
        
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
          
          self.closeAllMenus();
          self.getQuestions();
        }
      }

      var sendData = {
        QuestionId: self.selectedQuestion.id,
        Answer: self.teacherAnswer,
        IsPublic: self.publicAnswer,
      }
    
      self.$ajaxPost(self, "teacher/TaskQA/submitQuestionAnswer" , sendData , onSuccess, onFinally);
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    getQuestions(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");
      var onSuccess = response =>{
        self.data = response.data;
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
    
      self.$ajaxGet(self, "teacher/TaskQA/list" , onSuccess, onFinally);
    },
  },
  mounted() { 
    var self = this;
    self.getQuestions();
  },
}
</script>


<style lang="scss"> 
#teacher-qa{
  .vs-textarea{
    background: white !important;
    color: black !important;
  }
}
</style>